/**
 * File: ResetPasswordPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.1.1
 * Created: 2025-07-23
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// Local project files
import { TextButton } from "../components/ui/Buttons";
import { resetPassword } from "../utils/ServiceRequests";
import { routes } from "../constants/routes";
import AuthPrompt from "../components/forms/AuthPrompt";
import FormHeader from "../components/forms/FormHeader";
import Logo from "../components/ui/Logo";
import PasswordField from "../components/forms/PasswordField";
import PasswordMatchField from "../components/forms/PasswordMatchField";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ResetPasswordPage({ schema, otpEmail }) {
    const [newPassword, setNewPassword] = useState("");

    const redirect = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await resetPassword(otpEmail, newPassword);
            redirect(routes.public.auth.signIn.abs);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <>
            <article className="auth__article">
                <form className="auth__form" onSubmit={handleSubmit}>
                    <Logo isLink={true} />
                    <FormHeader {...schema.formHeader} />
                    <fieldset>
                        <PasswordField
                            label={"Password"}
                            id={"password-new"}
                            placeholder={"Password"}
                            password={newPassword}
                            setPassword={setNewPassword}
                            isValidationHint={true}
                        />
                        <PasswordMatchField
                            label={"Confirm Password"}
                            id={"password-confirm"}
                            placeholder={"Confirm Password"}
                            newPassword={newPassword}
                        />
                    </fieldset>
                    <TextButton
                        {...schema.textButton}
                        onClick={handleSubmit}
                    ></TextButton>
                    <hr></hr>
                    <AuthPrompt {...schema.authPrompt} />
                </form>
            </article>
        </>
    );
}

export default ResetPasswordPage;
